export default "__VITE_ASSET__875a891f__";